import { IToken } from '../typings/elements.typing';
import jwtDecode from 'jwt-decode';

export const getParsedToken = (): IToken => {
  const token: string = localStorage.getItem('accessToken') || '';
  return jwtDecode(token);
};
